export default "__VITE_ASSET__84622517__"